module.exports = __webpack_public_path__ + "static/benefitIcon3.1a55eeae.svg";